import { Component, OnInit, Input } from '@angular/core';
import { NotaEntity } from 'src/app/services/servicio-formato-asistencial.service';

@Component({
  selector: 'app-notas',
  templateUrl: './notas.component.html',
  styleUrls: ['./notas.component.css']
})
export class NotasComponent implements OnInit {

  @Input() public notas: NotaEntity[] = [];

  constructor() { }

  ngOnInit() {
  }

}
